import sunIcon from '../assets/sun.png';
import horizonIcon from '../assets/horizon.png';
import energyIcon from '../assets/energy.png';
import frogIcon from '../assets/froggy.png';
import resumeFile from '../assets/document/Erickendy Jean Pierre Resume 2026.pdf';

const apps = [
  {
    id: 'about',
    menuLabel: 'About Me',
    shellLabel: 'about-me.exe',
    category: 'Profile',
    accent: 'teal',
    icon: sunIcon,
    windowTitle: 'About Me',
    resumeFile: resumeFile,
    socialLinks: [
      { label: 'LinkedIn', url: 'https://www.linkedin.com/in/erickendy-jean/' },
      { label: 'GitHub', url: 'https://github.com/latenight-dev' },
    ],
    summary:
      'Game developer with web experience in React, AngularJS, Node.js, and more — I help bring game designs from idea to reality.',
    cards: [
      {
        heading: 'Who I Am',
        body:
          'I\'m Erickendy Jean Pierre — a game developer based in New Britain, CT with deep web experience across React, AngularJS, Node.js, and other code stacks. I bring game designs from idea to reality, building production games and polished interactive experiences.',
      },
      {
        heading: 'How I Work',
        body:
          'I take game concepts from design to release across UI, state logic, and backend integration — ensuring stable launches and consistent player experiences. I work closely with designers and product teams to deliver engaging gameplay and polished interfaces.',
      },
    ],
    details: [
      'Experience: Senior Front-End Engineer at ELB Learning (June 2017 – April 2026), remote.',
      'Education: M.S. Computer Science at Georgia Institute of Technology (Aug 2024 – May 2028); B.A. Digital Media and Design at University of Connecticut (2013 – 2017).',
      'Front-End: CSS, HTML, JavaScript, AngularJS, Python, React, Vue3, Xstate, C#.',
      'Back-End: Node.js, MongoDB, PostgreSQL, Express.js.',
      'Misc: Git, GitHub, Jira, Photoshop, Illustrator, After Effects.',
      'Cert: CompTIA IT Fundamentals+.',
    ],
  },
  {
    id: 'project-one',
    menuLabel: 'Horizon Optical Drones',
    shellLabel: 'horizon-optical-drones.app',
    category: 'Featured Project',
    accent: 'amber',
    icon: horizonIcon,
    windowTitle: 'Horizon Optical Drones',
    iframeSrc: 'https://horizonopticaldrones.com',
    socialLinks: [
      { label: '▶ YouTube', url: 'https://www.youtube.com/@horizonopticaldrones/videos' },
      { label: 'Instagram', url: 'https://www.instagram.com/horizon_optical_drones/' },
    ],
    summary:
      'Established 2023-present. A business website built to market drone services and generate client leads.',
    cards: [
      {
        heading: 'Business Website',
        body:
          'horizonopticaldrones.com presents the brand, explains available services, and helps potential clients quickly understand what Horizon Optical Drones provides.',
      },
      {
        heading: 'Services Offered',
        body:
          'Aerial photography, construction updates, solar surveys, roof inspections, and image capture for CAD-focused workflows.',
      },
    ],
    details: [
      'Website: horizonopticaldrones.com',
      'Timeline: established in 2023 and active through present.',
      'Goal: market professional drone services and convert visitors into customer inquiries.',
    ],
  },
  {
    id: 'project-two',
    menuLabel: 'Energy Control',
    shellLabel: 'energy-control.app',
    category: 'Featured Project',
    accent: 'rose',
    icon: energyIcon,
    windowTitle: 'Energy Control',
    iframeSrc: 'https://energycontrolfinance.com',
    summary:
      'A gamified finance app available on Steam that turns healthy financial habits into a city-builder experience. Official launch: April 24, 2026.',
    cards: [
      {
        heading: 'Finance & Management',
        body:
          'Manage all your accounts in one place: link and track checking, savings, credit, and external services. Simulate future incomes and budgets, forecast cash flow, and manage investments including crypto, stocks, NFTs, and TCG playing cards. Energy Control is a third-party affiliate with TCGplayer, letting users quickly purchase cards to expand collections. The more historical data you provide, the better the app\'s predictive insights — view net worth, lifetime earnings, and granular transaction analysis.',
      },
      {
        heading: 'City Builder',
        body:
          'Spend earned coins and XP to grow a living, expanding city: build homes, offices, factories, solar farms, and wind arrays. Offices and factories generate ongoing revenue; NPC activities and vehicle logistics produce additional income. The city can expand indefinitely across procedurally-connected districts, and includes NPC and vehicle AI systems that manage movement, jobs, and deliveries.',
      },
      {
        heading: 'Tech Stack',
        body:
          'Built with Node.js and React for the app, SQLite for local on-device storage, and Phaser 3 for the city-builder gameplay and interactive systems.',
      },
      {
        heading: 'Privacy First',
        body:
          'All data stays on device — Energy Control never sends your information out. No subscriptions, no hidden fees. Download it once on Steam and everything runs locally.',
      },
    ],
    details: [
      'Platform: available to download on Steam.',
      'Website: energycontrolfinance.com',
      'Launch date: April 24, 2026.',
      'Privacy: all data is kept on device with zero external data transmission.',
      'Core loop: earn coins and XP from financial habits, use rewards to build and expand your city, and monitor finances across accounts and investments.',
      'Affiliate: integrated TCGplayer affiliate links for purchasing playing cards directly in the app.',
      'Systems: includes refined NPC activity and vehicle algorithms to manage movement, jobs, and deliveries across the city.',
    ],
  },
  {
    id: 'croak-quest',
    menuLabel: 'CroakQuest',
    shellLabel: 'croak-quest.app',
    category: 'Class Project',
    accent: 'green',
    icon: frogIcon,
    windowTitle: 'CroakQuest',
    videoSrc: 'https://www.dropbox.com/scl/fi/toaxoqfwpri5d4pygx7sx/MysticEmberGames_CroakQuest_Trailer.mp4?rlkey=cmkokrd6s2nsa4ngs1jhgg9rp&e=1&st=yunarpok&raw=1',
    summary:
      'A Unity 3D game built as a group project for CS 6457 Video Game Design in my Master\'s program at Georgia Tech.',
    cards: [
      {
        heading: 'Gameplay',
        body:
          'Play as a frog hopping lily pad to lily pad, dodging obstacles and fighting enemies. Hop across treacherous swamps, shoot your tongue to grab items, and spit flies at enemies to defeat them.',
      },
      {
        heading: 'Enemies & Boss',
        body:
          'Battle slimes, turtles, and bees as you progress through the levels. The final boss is an alligator modeled in Blender — a custom 3D asset brought to life in Unity.',
      },
      {
        heading: 'Tech Stack',
        body:
          'Built in Unity 3D with C#. 3D models and the alligator boss created in Blender. Available on PC and Mac.',
      },
    ],
    details: [
      'Course: CS 6457 Video Game Design — Georgia Institute of Technology.',
      'Type: group project built collaboratively with classmates.',
      'Engine: Unity 3D with builds for PC and Mac.',
      'Player abilities: hop, tongue attack, fly spit projectile.',
      'Enemies: slime, turtles, bees, and an alligator boss made in Blender.',
    ],
  },
];

export default apps;
